export interface DocMeta {
    name: string;
    value: string;
}

export function getMetaValue(meta: DocMeta[], name: string) {
    const result = meta.find((m) => m.name === name);

    if (!result) {
        return;
    }

    const v = result.value;
    if (name === "authors") {
        return v.split("؛").join("، ");
    }

    return v;
}
